import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useReducer } from 'react';
import { NavMarker } from 'react-rhumb';
import { useLocation, useParams } from 'react-router-dom';
import ThemeDetailsResponse from 'marketplace-ui-assets-core/details/records/ThemeDetailsResponse'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import HSPageViewTracker from 'ecosystem-marketplace-core/components/tracking/HSPageViewTracker';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message

import { usePrevious } from 'ecosystem-marketplace-core/hooks/usePrevious';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import MetaRobots from 'ecosystem-marketplace-core/components/elements/MetaRobots';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady';
import PrerenderStatusCode from 'ecosystem-marketplace-core/components/prerender/PrerenderStatusCode';
import { updateThemeSlug, resetThemeSlug } from '../actions/ThemeDetailsActions';
import { getThemeDetails } from '../clients/ecosystemClient';
import { useAppDispatch } from '../reducers';
import { PublicAppContext } from '../selectors/app';
import { getRootUrl } from '../utils/urls';
import ThemeDetailsPage from '../themes/components/ThemeDetailsPage';
import NotFoundError from '../components/error/NotFoundError';
import NoAccessError from '../components/error/NoAccessError'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../c... Remove this comment to see the full error message

import GenericError from '../components/error/GenericError'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../c... Remove this comment to see the full error message

import StorefrontUsageTrackerProvider from '../context/StorefrontUsageTrackerProvider';
const ActionTypes = {
  THEME_DETAILS_REQUESTED: 'THEME_DETAILS_REQUESTED',
  THEME_DETAILS_RECEIVED: 'THEME_DETAILS_RECEIVED',
  THEME_DETAILS_FAILED: 'THEME_DETAILS_FAILED',
  THEME_DETAILS_RESET: 'THEME_DETAILS_RESET'
};
const initialState = {
  requestState: RequestStates.UNINITIALIZED,
  themeDetails: null,
  errorStatus: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.THEME_DETAILS_REQUESTED:
      {
        return Object.assign({}, state, {
          requestState: RequestStates.PENDING,
          themeDetails: null
        });
      }

    case ActionTypes.THEME_DETAILS_RECEIVED:
      {
        return Object.assign({}, state, {
          requestState: RequestStates.SUCCEEDED,
          themeDetails: new ThemeDetailsResponse(action.payload)
        });
      }

    case ActionTypes.THEME_DETAILS_FAILED:
      {
        return Object.assign({}, state, {
          requestState: RequestStates.FAILED,
          themeDetails: null,
          errorStatus: action.payload.status
        });
      }

    case ActionTypes.THEME_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};

const ThemeDetailsError = ({
  children
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(PublicAppContext, {
    children: /*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx(MetaRobots, {
        directive: ['nofollow', 'noindex']
      }), /*#__PURE__*/_jsx(PrerenderReady, {}), /*#__PURE__*/_jsx(PrerenderStatusCode, {
        statusCode: 404
      })]
    })
  }), children]
});

const ThemeDetailsContainer = () => {
  const {
    pathname
  } = useLocation(); // @ts-expect-error ts-migrate(2339) FIXME: Property 'slug' does not exist on type '{}'.

  const {
    slug
  } = useParams();
  const prevSlug = usePrevious(slug);
  const appDispatch = useAppDispatch();
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    requestState,
    themeDetails,
    errorStatus
  } = state;
  useEffect(() => {
    if (requestState === RequestStates.UNINITIALIZED) {
      dispatch({
        type: ActionTypes.THEME_DETAILS_REQUESTED
      });
      getThemeDetails(slug).then(resp => {
        dispatch({
          type: ActionTypes.THEME_DETAILS_RECEIVED,
          payload: resp
        });
      }).catch(error => {
        console.error('error fetching theme\n', error);
        dispatch({
          type: ActionTypes.THEME_DETAILS_FAILED,
          payload: error
        });
      });
    }
  }, [requestState, slug]);
  useEffect(() => {
    if (prevSlug && prevSlug !== slug) {
      dispatch({
        type: ActionTypes.THEME_DETAILS_RESET
      });
    }
  }, [prevSlug, slug]);
  useEffect(() => {
    appDispatch(updateThemeSlug(slug));
    return () => {
      appDispatch(resetThemeSlug());
    };
  }, [appDispatch, slug]);

  if (errorStatus) {
    if (errorStatus === 404) {
      return /*#__PURE__*/_jsx(ThemeDetailsError, {
        children: /*#__PURE__*/_jsx(NavMarker, {
          name: "THEME_DETAILS_404_LOAD",
          children: /*#__PURE__*/_jsx(NotFoundError, {})
        })
      });
    }

    if (errorStatus === 403) {
      return /*#__PURE__*/_jsx(ThemeDetailsError, {
        children: /*#__PURE__*/_jsx(NavMarker, {
          name: "THEME_DETAILS_403_LOAD",
          children: /*#__PURE__*/_jsx(NoAccessError, {})
        })
      });
    }

    return /*#__PURE__*/_jsx(ThemeDetailsError, {
      children: /*#__PURE__*/_jsx(NavMarker, {
        name: "THEME_DETAILS_ERROR_LOAD",
        children: /*#__PURE__*/_jsx(GenericError, {})
      })
    });
  }

  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerProvider, {
    children: [slug === prevSlug && requestState === RequestStates.SUCCEEDED ? /*#__PURE__*/_jsx(ThemeDetailsPage, {
      themeDetails: themeDetails
    }, `theme-details-${slug}`) : null, /*#__PURE__*/_jsx(HSPageViewTracker, {
      pathname: `${getRootUrl()}${pathname}`
    })]
  });
};

export default ThemeDetailsContainer;